/**
 * BookingInventoryAuditService — "scan everything in this storage room" flow.
 *
 * Lifecycle: start() → many scan() calls → close() returns the report
 *  (or call report() at any time during the session).
 *
 * Route: api/inventory-audits
 */
import { BaseService } from '../base';
import { ScanType } from './BookableResourceService';
export class BookingInventoryAuditService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingInventoryAuditService.DEFAULT_SERVICE_PATH,
            basePath: 'api/inventory-audits',
            endpoints: config?.endpoints,
        });
    }
    async list() {
        const r = await this.http.get(this.buildUrl());
        return r.data ?? [];
    }
    async start(request) {
        const r = await this.http.post(this.buildUrl(), {
            LocationID: request.locationID ?? null,
            ResourceTypeID: request.resourceTypeID ?? null,
            Notes: request.notes ?? null,
        });
        return r.data ?? null;
    }
    async scan(auditId, scannedCode, type = ScanType.Auto) {
        const r = await this.http.post(this.buildUrl(`${auditId}/scan`), { ScannedCode: scannedCode, Type: type });
        return r.data ?? null;
    }
    async listScans(auditId) {
        const r = await this.http.get(this.buildUrl(`${auditId}/scans`));
        return r.data ?? [];
    }
    async report(auditId) {
        const r = await this.http.get(this.buildUrl(`${auditId}/report`));
        return r.data ?? null;
    }
    async close(auditId, cancelled = false) {
        const r = await this.http.put(this.buildUrl(`${auditId}/close?cancelled=${cancelled ? 'true' : 'false'}`), {});
        return r.data ?? null;
    }
}
BookingInventoryAuditService.DEFAULT_SERVICE_PATH = 'booking-management';
//# sourceMappingURL=BookingInventoryAuditService.js.map